import type {
  EventHandlerCb,
  ExtendedConstraints,
  CapabilityConfig,
} from '../../../types';
import {
  type ParticipantId,
  type Participant,
  type ParticipantMessage,
  type Message,
  type ParticipantAction,
  type Action,
  type MultiplayerConfig,
  isValidConfig as isValidMultiplayerConfig,
} from '../multiplayer';

export const id = 'multiplayer-call';

export enum Events {
  Joined = 'multiplayer-call:joined',
  Departed = 'multiplayer-call:departed',
  Message = 'multiplayer-call:message',
  ParticipantList = 'multiplayer-call:participant-list',
  RealtimeId = 'multiplayer-call:realtime-id',
}
export enum Actions {
  SendMessage = 'multiplayer-call:send-message',
  SendMessageAll = 'multiplayer-call:send-message-all',
  SendAction = 'multiplayer-call:trigger-action',
  SendActionAll = 'multiplayer-call:trigger-action-all',
  RequestParticipants = 'multiplayer-call:request-participants',
  RequestRealtimeId = 'multiplayer-call:request-realtime-id',
}

export type Config = MultiplayerConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  eventPayloadTuple:
    | [Events.Joined, Participant[]]
    | [Events.Departed, Participant[]]
    | [Events.Message, ParticipantMessage]
    | [Events.ParticipantList, Participant[]]
    | [Events.RealtimeId, ParticipantId];
  eventHandlerTuple:
    | [Events.Joined, EventHandlerCb<Participant[]>]
    | [Events.Departed, EventHandlerCb<Participant[]>]
    | [Events.Message, EventHandlerCb<ParticipantMessage>]
    | [Events.ParticipantList, EventHandlerCb<Participant[]>]
    | [Events.RealtimeId, EventHandlerCb<ParticipantId>];
  actionPayloadTuple:
    | [Actions.SendMessage, ParticipantMessage]
    | [Actions.SendMessageAll, Message]
    | [Actions.SendAction, ParticipantAction]
    | [Actions.SendActionAll, Action]
    | [Actions.RequestParticipants]
    | [Actions.RequestRealtimeId];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!isValidMultiplayerConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
